import { render, staticRenderFns } from "./index.vue?vue&type=template&id=097a3e79"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097a3e79')) {
      api.createRecord('097a3e79', component.options)
    } else {
      api.reload('097a3e79', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=097a3e79", function () {
      api.rerender('097a3e79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/order/index.vue"
export default component.exports